// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/n-column-canvas/n-column-canvas.component.css
// module id = 761
// module chunks = 0